(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
(function () {
  var menu = document.getElementById('mmenu');
  if (!menu) return;
  var opener = document.querySelector('[data-menu-open]');
  var lastFocused = null;

  function open() {
    lastFocused = document.activeElement;
    menu.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    var focusable = menu.querySelector('button, a[href]');
    if (focusable) focusable.focus();
    document.addEventListener('keydown', onKey);
  }
  function close() {
    menu.hidden = true;
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKey);
    if (lastFocused && lastFocused.focus) lastFocused.focus();
  }
  function onKey(e) { if (e.key === 'Escape') close(); }

  if (opener) opener.addEventListener('click', open);
  menu.querySelectorAll('[data-menu-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  var bg = document.getElementById('hero-bg');
  var sec = document.getElementById('hero');
  if (!bg || !sec) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  function px() {
    if (window.innerWidth <= 860) { bg.style.transform = ''; return; }
    var r = sec.getBoundingClientRect();
    if (r.bottom < 0 || r.top > window.innerHeight) return;
    bg.style.transform = 'translateY(' + (-r.top * 0.28) + 'px)';
  }
  window.addEventListener('scroll', px, { passive: true });
  window.addEventListener('resize', px);
  px();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-offer"] && !Shopify.designMode) return;
  try {
    
(function () {
  function scale(scope) {
    var root = scope && scope.querySelector ? scope : document;
    var o = root.querySelector('#s5-lp-outer');
    var i = o && o.querySelector('#s5-lp-inner');
    if (!o || !i) return;
    var w = o.clientWidth;
    if (!w) return;
    var s = w / 900;
    i.style.transform = 'scale(' + s + ')';
    o.style.height = 590 * s + 'px';
  }
  function boot() { scale(document); }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  window.addEventListener('load', boot);
  window.addEventListener('resize', boot);

  // Theme editor: re-scale when the section is re-rendered / selected
  document.addEventListener('shopify:section:load', function (e) { scale(e.target); });
  document.addEventListener('shopify:section:select', function (e) { scale(e.target); });

  if ('ResizeObserver' in window) {
    try {
      var target = document.querySelector('#s5-lp-outer');
      if (target) new ResizeObserver(function () { scale(document); }).observe(target.parentElement || target);
    } catch (err) {}
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-story"] && !Shopify.designMode) return;
  try {
    
(function () {
  function draw(eye) {
    function reveal() {
      eye.querySelectorAll('[pathLength]').forEach(function (el) { el.style.strokeDashoffset = '0'; });
      var pupil = eye.querySelector('circle[fill]');
      if (pupil) pupil.style.opacity = '1';
    }
    if (!('IntersectionObserver' in window)) { reveal(); return; }
    new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (e) { if (e.isIntersecting) { reveal(); obs.unobserve(e.target); } });
    }, { threshold: 0.4 }).observe(eye);
  }
  document.querySelectorAll('.oracle-eye').forEach(draw);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-close"] && !Shopify.designMode) return;
  try {
    
(function () {
  var icon = document.getElementById('h12-breath-spiral');
  if (!icon) return;
  function reveal() {
    icon.querySelectorAll('[pathLength]').forEach(function (el) { el.style.strokeDashoffset = '0'; });
  }
  if (!('IntersectionObserver' in window)) { reveal(); return; }
  new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { reveal(); obs.unobserve(e.target); }
    });
  }, { threshold: 0.15 }).observe(icon);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-s12"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('.s12-item').forEach(function (item) {
    var btn = item.querySelector('.s12-q');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var wasOpen = item.classList.contains('is-open');
      document.querySelectorAll('.s12-item.is-open').forEach(function (open) {
        if (open !== item) {
          open.classList.remove('is-open');
          open.querySelector('.s12-q').setAttribute('aria-expanded', 'false');
        }
      });
      item.classList.toggle('is-open', !wasOpen);
      btn.setAttribute('aria-expanded', String(!wasOpen));
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-s8-included"] && !Shopify.designMode) return;
  try {
    
(function () {
  var lib = document.getElementById('lib');
  if (!lib) return;
  var tabs = lib.querySelectorAll('.lib-tab'), i;

  function activate(tab) {
    for (i = 0; i < tabs.length; i++) {
      var on = tabs[i] === tab;
      tabs[i].classList.toggle('is-active', on);
      tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      var p = document.getElementById('lib-panel-' + tabs[i].getAttribute('data-panel'));
      if (p) p.hidden = !on;
    }
  }
  for (i = 0; i < tabs.length; i++) {
    tabs[i].addEventListener('click', function () { activate(this); });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sales-s8-practice"] && !Shopify.designMode) return;
  try {
    
(function () {
  var outer = document.getElementById('s8p-phone-outer'),
      inner = document.getElementById('s8p-phone-inner');
  if (!outer || !inner) return;

  function fit() {
    var s = outer.offsetWidth / 300;
    inner.style.transform = 'scale(' + s + ')';
    outer.style.height = (620 * s) + 'px';
  }
  function boot() {
    fit();
    if ('ResizeObserver' in window) new ResizeObserver(fit).observe(outer);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  window.addEventListener('load', fit);
  document.addEventListener('shopify:section:load', fit);
  document.addEventListener('shopify:section:select', fit);

  // Real <audio> preview — progress bar + time read the media element.
  var btn = document.getElementById('s8p-play'),
      playIcon = document.getElementById('s8p-icon-play'),
      pauseIcon = document.getElementById('s8p-icon-pause'),
      fill = document.getElementById('s8p-fill'),
      time = document.getElementById('s8p-time'),
      audio = document.getElementById('s8p-audio');
  if (!btn || !audio) return;

  function fmt(sec) {
    sec = Math.max(0, Math.floor(sec || 0));
    var m = Math.floor(sec / 60), s = sec % 60;
    return m + ':' + (s < 10 ? '0' + s : s);
  }
  function render() {
    var d = isFinite(audio.duration) ? audio.duration : 0, c = audio.currentTime || 0;
    fill.style.width = (d ? (c / d * 100) : 0) + '%';
    time.textContent = fmt(c) + ' / ' + fmt(d);
  }
  function setPlaying(on) {
    playIcon.style.display = on ? 'none' : '';
    pauseIcon.style.display = on ? '' : 'none';
  }
  audio.addEventListener('loadedmetadata', render);
  audio.addEventListener('timeupdate', render);
  audio.addEventListener('play', function () { setPlaying(true); });
  audio.addEventListener('pause', function () { setPlaying(false); });
  audio.addEventListener('ended', function () { setPlaying(false); audio.currentTime = 0; render(); });
  btn.addEventListener('click', function () {
    if (audio.paused) { var p = audio.play(); if (p && p.catch) p.catch(function () {}); }
    else { audio.pause(); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
